import img1 from "@/assets/images/journeyImages/final edit.jpg";
import img2 from "@/assets/images/journeyImages/final edit1.jpg";
import img3 from "@/assets/images/journeyImages/final edit2.png";
import img4 from "@/assets/images/journeyImages/final edit3.jpg";
import img5 from "@/assets/images/journeyImages/final edit4.jpg";
import img6 from "@/assets/images/journeyImages/final edit5.jpg";
import img7 from "@/assets/images/journeyImages/final edit6.jpg";
import img8 from "@/assets/images/journeyImages/final edit7.jpg";
import img10 from "@/assets/images/journeyImages/738562a3534ad3d8c1e6d2e7049930c50b342a0d.jpg";
import img11 from "@/assets/images/journeyImages/95f1b540aef20e18d01f38dc42f312ad857af9ab.jpg";
import img12 from "@/assets/images/journeyImages/a9a8c6e1fdb57e18cdc414d2a6b983aac65a83e8.jpg";
import img14 from "@/assets/images/journeyImages/db380e0ce28decaea0a3d8eec73d0318fb6ff33c.jpg";
import img15 from "@/assets/images/journeyImages/e11ca702cf1ef5cc4f47332ffbfdcce73a9fe8fb.jpg";

export const coreStats = [
  { value: "25", label: "Tiriamos sveikatos sritys" },
  { value: "15", label: "Klinikinių susitikimų" },
];

export const apexStats = [
  { value: "35", label: "Tiriamos sveikatos sritys" },
  { value: "20", label: "Klinikinių susitikimų" },
];

export const coreFeatures = [
  "25 sveikatos sričių įvertinimas",
  "Platus kraujo ištyrimas",
  "Gyvensenos genetinis tyrimas",
  "Ištvermės VO₂max testavimas",
  "Ramybės būsenos VO₂max testavimas",
  "Kūno sudėties ir jėgos matavimas",
  "6 medicinos ekspertų konsultacijos",
  "12 savaičių gyvensenos korekcijos programa",
  "Bazinė maisto papildų prenumerata",
  "Pakartotiniai kraujo tyrimai",
];

export const apexFeatures = [
  "35 sveikatos sričių įvertinimas",
  "Klinikinio genomo tyrimas",
  "Farmakogenetinis vaistų pasisavinamumo tyrimas",
  "Gyd. genetiko retų ligų identifikavimas",
  "Gyd. genetiko šeimos planavimo strategija",
  "Platus kraujo ištyrimas",
  "Gyvensenos genetinis tyrimas",
  "Ištvermės VO₂max testavimas",
  "Ramybės būsenos VO₂max testavimas",
  "Kūno sudėties ir jėgos matavimas",
  "Nuolatinis gliukozės stebėjimas (CGS)",
  "Asmeninė paciento vadyba ir priežiūra",
  "8 medicinos ekspertų konsultacijos",
  "12 savaičių gyvensenos korekcijos programa",
  "Bazinė maisto papildų prenumerata",
  "Pakartotiniai kraujo tyrimai",
  "Pakartotiniai VO₂max, kūno sudėties ir jėgos matavimai",
  "Prieiga prie LifeTelos™ operacinės sveikatos sistemos",
];

export const journey = [
  {
    title: "Pradinis skambutis su pacientų vadybininke",
    description:
      "Tai pirmas kontaktas, kurio tikslas - užtikrinti, kad pacientas suprastų visą kelionę dar prieš pradedant diagnostiką.",
    timeLabel: "0 diena",
    core: true,
    apex: true,
    img: img1,
  },
  {
    title: "Gyvensenos klausimyno pildymas",
    description:
      "Šie duomenys leidžia suprasti ne tik biologinę, bet ir elgesio pusę - kaip žmogus gyvena realybėje esamuoju metu.",
    timeLabel: "1 diena",
    core: true,
    apex: true,
    img: img2,
  },
  {
    title: "Įvadinė konsultacija su gyvensenos specialiste",
    description:
      "Jos metu tikslinami pagrindiniai tikslai, aptariama esama sveikatos situacija. Parenkami reikalingi tyrimai, sudaromas individualus diagnostikos planas ir susitariamas tolimesnių patikrinimų dažnis.",
    timeLabel: "1 diena",
    core: true,
    apex: true,
    img: img3,
  },
  {
    title: "Diagnostikos diena",
    description:
      "Mėginių tyrimams pridavimas, VO₂max, kūno sudėtis, jėgos matavimas. Šie duomenys sudaro objektyvų biologinį „starto tašką“, kuris vėliau naudojamas pokyčiams matuoti.",
    timeLabel: "Po savaitės",
    core: true,
    apex: true,
    img: img15,
  },
  {
    title: "Kraujo tyrimų vertinimas su šeimos gydytoja",
    description:
      "Nustatomos prioritetinės rizikos ir būklės, kurios turi didžiausią įtaką sveikatai bei gyvensenos aptarimas.",
    timeLabel: "Po 2 savaičių",
    core: true,
    apex: true,
    img: img4,
  },
  {
    title: "Gyvensenos konsultacija (20 min.)",
    description:
      "Visa informacija sujungiama į vieną aiškią intervencijos strategiją: mityba, judėjimas, miegas, stresas.",
    timeLabel: "Po 3 savaičių",
    core: true,
    apex: true,
    img: img6,
  },
  {
    title: "Farmacininko konsultacija",
    description:
      "Sudaromas individualus papildų protokolas pagal kraujo ir funkcinės diagnostikos rezultatus.",
    timeLabel: "Po 3 savaičių",
    core: true,
    apex: true,
    img: img11,
  },
  {
    title: "Gyvensenos konsultacijos, plano korekcijos",
    description:
      "Korekcijos pagal realią patirtį: kas veikia, kas per sunku, kas reikalauja adaptacijos bei trumpi pasitikrinimai.",
    timeLabel: "Po 4-6 savaičių",
    core: true,
    apex: true,
    img: img8,
  },
  {
    title: "Gyvensenos genetikos konsultacija",
    description:
      "Aptariami genetiniai duomenys: kaip genetika veikia mitybą, sportą, stresą, miegą ir atsistatymą.",
    timeLabel: "Po 7 savaičių",
    core: true,
    apex: true,
    img: img3,
  },
  {
    title: "Farmacininko konsultacija (3 mėn. papildų strategija)",
    description: "Papildų planas atnaujinamas pagal genetinius polinkius.",
    timeLabel: "Po 8 savaičių",
    core: true,
    apex: true,
    img: img7,
  },
  {
    title: "Trumpas pasitikrinimas su gyvensenos specialiste",
    description: "",
    timeLabel: "Po 9 savaičių",
    core: true,
    apex: true,
    img: img1,
  },
  {
    title: "Klinikinio genomo tyrimo rezultatų aptarimas su gydytoja genetike",
    description:
      "Išsamus paveldimų ligų, onkologinių sindromų ir prevencinių strategijų aptarimas.",
    timeLabel: "Po 9 savaičių",
    core: false,
    apex: true,
    img: img5,
  },
  {
    title: "Gyvensenos konsultacijos",
    description: "Koreguojamos pagal naujai gautus rezultatus.",
    timeLabel: "Po 10-11 savaičių",
    core: true,
    apex: true,
    img: img10,
  },
  {
    title: "Pakartotiniai tyrimai ir rezultatų peržiūra",
    description:
      "Pakartotiniai kraujo tyrimai ir VO₂max, kūno sudėties bei jėgos matavimai ir rezultatų peržiūra bei įvertiniams",
    timeLabel: "Po 12 savaičių",
    core: true,
    apex: true,
    img: img14,
  },
  {
    title: "Kasmėnesiniai palaikomieji gyvensenos check-in'ai",
    description: "",
    timeLabel: "Po programos",
    core: true,
    apex: true,
    img: img12,
  },
];
